export function useScrollReveal() {
  function reveal() {
    if (!import.meta.client) return
    document.querySelectorAll('.animate-in, .fly-in').forEach((el) => {
      const rect = el.getBoundingClientRect()
      if (rect.top < window.innerHeight - 60) {
        el.classList.add('visible')
      }
    })
  }

  onMounted(() => {
    reveal()
    window.addEventListener('scroll', reveal, { passive: true })
    onUnmounted(() => window.removeEventListener('scroll', reveal))
  })

  return { reveal }
}
